import { ApplicationTypes, attachAdminComponent } from 'higgins-domain'

import { createAdminPages } from '@salsita-ai/platform-project-sdk/admin'
import {
  adminSidebarComponent,
  memoEval,
  navigationPageComponent,
  navigationPanelListComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { ColorsSidebar } from './ui/ColorsSidebar'
import { MaterialsPage } from './ui/MaterialsPage'
import { SegmentPricesPage } from './ui/SegmentPricesPage'
import { WoodTextureSidebar } from './ui/WoodTextureSidebar'

const { commonComponents: commonAdminComponents, commonPages } = createAdminPages({})

export const customAdminOptics = [
  ...commonAdminComponents,

  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'segmentPrices')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.SegmentPrices],
    })
    .attach(
      memoEval(
        () => [],
        () => ({
          title: 'Segment Prices',
          breadcrumbs: [],
          content: <SegmentPricesPage />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'cabinetColors')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.CabinetColors],
    })
    .attach(
      memoEval(
        () => [],
        () => ({
          title: 'Cabinet Colors',
          breadcrumbs: [],
          content: <MaterialsPage entity="CabinetColor" />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPageComponent, 'countertopColors')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.CountertopColors],
    })
    .attach(
      memoEval(
        () => [],
        () => ({
          title: 'Countertop Colors',
          breadcrumbs: [],
          content: <MaterialsPage entity="CountertopColor" />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('CabinetSolidColorMaterial')
    .withComponent(adminSidebarComponent, 'cabinetColorsSidebar')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.CabinetColors],
      selectedEntityIds: s => [s.id],
    })
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          title: 'Edit Color',
          page: <ColorsSidebar id={id} />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('CabinetWoodTextureMaterial')
    .withComponent(adminSidebarComponent, 'cabinetWoodColorsSidebar')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.CabinetColors],
      selectedEntityIds: s => [s.id],
    })
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          title: 'Edit Wood Texture',
          page: <WoodTextureSidebar id={id} />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('CountertopSolidColorMaterial')
    .withComponent(adminSidebarComponent, 'countertopColorsSidebar')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.CountertopColors],
      selectedEntityIds: s => [s.id],
    })
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          title: 'Edit Color',
          page: <ColorsSidebar id={id} />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('CountertopWoodTextureMaterial')
    .withComponent(adminSidebarComponent, 'countertopWoodColorsSidebar')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.CountertopColors],
      selectedEntityIds: s => [s.id],
    })
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          title: 'Edit Wood Texture',
          page: <WoodTextureSidebar id={id} />,
        })
      )
    ),

  attachAdminComponent
    .withEntity('Admin')
    .withComponent(navigationPanelListComponent, 'main')
    .attach(
      memoEval(
        () => [],
        () => ({
          items: [
            ...commonPages,
            {
              label: 'Prices',
              icon: 'TagBold',
              navigationStates: [ApplicationTypes.AdminNavigationState.SegmentPrices],
            },
            {
              label: 'Cabinet Colors',
              icon: 'PaletteBold',
              navigationStates: [ApplicationTypes.AdminNavigationState.CabinetColors],
            },
            {
              label: 'Countertop Colors',
              icon: 'PaletteBold',
              navigationStates: [ApplicationTypes.AdminNavigationState.CountertopColors],
            },
          ],
        })
      )
    ),
]
